import React from "react";
import type { Category, CategoryType } from "@/types/finance";

type Props = {
  isOpen: boolean;
  sheetTitle: string;
  setSheetTitle: (value: string) => void;
  editingId: string | null;
  name: string;
  setName: (value: string) => void;
  type: CategoryType;
  setType: (value: CategoryType) => void;
  parentId: string;
  setParentId: (value: string) => void;
  availableParents: Category[];
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
};

const CategoryModal: React.FC<Props> = ({
  isOpen,
  sheetTitle,
  setSheetTitle,
  editingId,
  name,
  setName,
  type,
  setType,
  parentId,
  setParentId,
  availableParents,
  onClose,
  onSubmit,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-zinc-900/60 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      <div className="bg-white w-full max-w-lg rounded-3xl shadow-2xl relative z-10 p-6 sm:p-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-black text-zinc-900 tracking-tight">
            {editingId ? "Editar Categoria" : "Nova Categoria"}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-zinc-100 rounded-full text-zinc-400"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={onSubmit} className="space-y-6">
          {/* <div>
            <label className="block text-xs font-black text-zinc-400 uppercase tracking-widest mb-2 ml-1">
              Nome da planilha
            </label>
            <input
              type="text"
              className="w-full px-5 py-4 border border-zinc-100 bg-zinc-50 rounded-2xl focus:bg-white focus:ring-2 focus:ring-[#3f83f8] outline-none font-bold text-zinc-800"
              placeholder="Ex: Minha Planilha"
              value={sheetTitle}
              onChange={(e) => setSheetTitle(e.target.value)}
            />
          </div> */}

          <div>
            <label className="block text-xs font-black text-zinc-400 uppercase tracking-widest mb-2 ml-1">
              Nome
            </label>
            <input
              type="text"
              required
              autoFocus
              className="w-full px-5 py-4 border border-zinc-100 bg-zinc-50 rounded-2xl focus:bg-white focus:ring-2 focus:ring-[#3f83f8] outline-none font-bold text-zinc-800"
              placeholder="Ex: Supermercado"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <button
              type="button"
              onClick={() => setType("income")}
              className={`py-4 rounded-2xl border-2 transition-all font-black text-xs ${
                type === "income"
                  ? "bg-blue-50 border-[#3f83f8] text-[#3f83f8]"
                  : "bg-white border-zinc-100 text-zinc-400"
              }`}
            >
              ENTRADA
            </button>
            <button
              type="button"
              onClick={() => setType("expense")}
              className={`py-4 rounded-2xl border-2 transition-all font-black text-xs ${
                type === "expense"
                  ? "bg-rose-50 border-rose-500 text-rose-600"
                  : "bg-white border-zinc-100 text-zinc-400"
              }`}
            >
              SAÍDA
            </button>
          </div>

          <div>
            <label className="block text-xs font-black text-zinc-400 uppercase tracking-widest mb-2 ml-1">
              Mãe
            </label>
            <select
              className="w-full px-5 py-4 border border-zinc-100 bg-zinc-50 rounded-2xl outline-none font-bold text-zinc-800 appearance-none"
              value={parentId}
              onChange={(e) => setParentId(e.target.value)}
            >
              <option value="">Nenhuma (Raiz)</option>
              {availableParents
                .filter((cat) => cat.type === type)
                .map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="flex flex-col gap-3 pt-4">
            <button
              type="submit"
              className="w-full py-5 bg-[#3f83f8] text-white rounded-2xl font-black text-sm tracking-widest uppercase transition-all shadow-xl shadow-blue-100"
            >
              {editingId ? "Salvar" : "Cadastrar"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full py-4 bg-zinc-50 text-zinc-400 rounded-2xl font-black text-xs uppercase tracking-widest"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryModal;
